import React, { useState, useEffect } from "react";
import VerticalSlick from "../Slick";
import survey from "../../../images/survey.png";
import quiz from "../../../images/quiz.png";
import chat from "../../../images/chat.png";
import headset from "../../../images/headset.png";
import teams from "../../../images/teams.png";
import award from "../../../images/award.png";
import play from "../../../images/play.png";
import todo from "../../../images/todo.png";
import virtualEvent from "../../../images/virtual-event.png";
import sos from "../../../images/sos.png";
import ideaboard from "../../../images/ideaboard.png";
import feedback from "../../../images/feedback.png";
import faq from "../../../images/faq.png";
import eMagazine from "../../../images/e-magazine.png";
import announcement from "../../../images/announcement.png";
import halloffame from "../../../images/halloffame.png";
import styles from "./BannerToolbar.module.scss";
import { useSelector } from "react-redux";
import { IoSettingsSharp } from "react-icons/io5";
import API from "../../../lib/apiLocal";

function BannerToolbar({ additionalClasses }) {
  const [isThubExpanded, setIsThubExpanded] = useState(false);
  const theme = useSelector((state) => state.public.theme.selected);
  const [featureList, setFeatureList] = useState([]);
  const [chats, setChat] = useState(true);
  const [todos, setTodos] = useState(true);
  const [gamess, setGames] = useState(true);
  const [feedbacks, setFeedback] = useState(null);
  const [soss, setSos] = useState(null);
  const [hof, setHof] = useState(null);
  const [ve, setVe] = useState(null);
  const [faqs, setFaq] = useState(null);
  const [quizs, setQuiz] = useState(null);
  const [surveys, setSurvey] = useState(null);
  const [ideaboards, setIdeaboard] = useState(null);
  const [announcements, setAnnouncement] = useState(null);
  const [helpdesks, setHelpdesk] = useState(null);
  const profileData = useSelector((state) => state.auth.myProfile);
  const featureData = useSelector(
    (state) => state.companyAdminPanel.featureUserList
  );
  console.log(profileData, "dadad");
  const [eMagazines, setEMagazines] = useState(null);

  // useEffect(() => {
  //   const handleMouseMove = (event) => {
  //     const mouseX = event.clientX;
  //     // const windowWidth = window.innerWidth;
  //     const rightCornerThreshold = 1365; // Adjust this value to define the threshold

  //     setIsMouseInRightCorner(mouseX > rightCornerThreshold);
  //   };

  //   window.addEventListener("mousemove", handleMouseMove);

  //   return () => {
  //     window.removeEventListener("mousemove", handleMouseMove);
  //   };
  // }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        if (
          profileData.client_user_details.user.email !==
          "superadmin@timbremedia.in"
        ) {
          const userFeature = await API.get("/api/client/user-feature/");
          setFeatureList(userFeature.data);
          userFeature.data.map((m) => {
            if (m.feature.display_name === "Feedback System") {
              if (m.is_enabled_client_user) {
                setFeedback(true);
                console.log(m.feature.display_name);
              } else {
                setFeedback(false);
              }
            } else if (m.feature.display_name === "Hall Of Fame") {
              if (m.is_enabled_client_user) {
                setHof(true);
              } else {
                setHof(false);
              }
            } else if (m.feature.display_name === "SOS") {
              if (m.is_enabled_client_user) {
                setSos(true);
              } else {
                setSos(false);
              }
            } else if (m.feature.display_name === "Faq Bot") {
              if (m.is_enabled_client_user) {
                setFaq(true);
              } else {
                setFaq(false);
              }
            } else if (m.feature.display_name === "Surveys") {
              if (m.is_enabled_client_user) {
                setSurvey(true);
              } else {
                setSurvey(false);
              }
            } else if (m.feature.display_name === "Idea Board") {
              if (m.is_enabled_client_user) {
                setIdeaboard(true);
              } else {
                setIdeaboard(false);
              }
            } else if (m.feature.display_name === "Announcements") {
              if (m.is_enabled_client_user) {
                setAnnouncement(true);
              } else {
                setAnnouncement(false);
              }
            } else if (m.feature.display_name === "Virtual Event") {
              if (m.is_enabled_client_user) {
                setVe(true);
              } else {
                setVe(false);
              }
            } else if (m.feature.display_name === "Quiz") {
              if (m.is_enabled_client_user) {
                setQuiz(true);
              } else {
                setQuiz(false);
              }
            } else if (m.feature.display_name === "E Magazine") {
              if (m.is_enabled_client_user) {
                setEMagazines(true);
              } else {
                setEMagazines(false);
              }
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, [profileData, featureData]);

  console.log(featureList, "fe");

  const toggleToolbar = () => {
    setIsThubExpanded(!isThubExpanded);
  };

  const slickData = [];

  console.log(feedbacks, "dd");
  console.log(surveys, "survey");
  console.log(quizs, "quiz");
  console.log(soss, "soso");

  if (feedbacks) {
    slickData.push({
      pic: feedback,
      link: "/feedback",
      tooltip: "Feedback",
    });
  }
  if (soss) {
    slickData.push({
      pic: sos,
      link: "/sos",
      tooltip: "SOS",
    });
  }
  if (surveys) {
    slickData.push({
      pic: survey,
      link: "/survey",
      tooltip: "Survey",
    });
  }
  if (quizs) {
    slickData.push({
      pic: quiz,
      link: "/quiz",
      tooltip: "Quiz",
    });
  }
  if (hof) {
    slickData.push({
      pic: halloffame,
      link: "/hall-of-fame",
      tooltip: "Hall of Fame",
    });
  }

  if (faqs) {
    slickData.push({
      pic: faq,
      link: "/faq",
      tooltip: "FAQ",
    });
  }
  if (ve) {
    slickData.push({
      pic: virtualEvent,
      link: "/virtual-event",
      tooltip: "Virtual Event",
    });
  }
  if (gamess) {
    slickData.push({
      pic: play,
      link: "/games",
      tooltip: "Games",
    });
  }
  if (helpdesks) {
    slickData.push({
      pic: headset,
      link: "/helpdesk",
      tooltip: "Helpdesk",
    });
  }
  if (announcements) {
    slickData.push({
      pic: announcement,
      link: "/announcements",
      tooltip: "Announcement",
    });
  }
  if (ideaboards) {
    slickData.push({
      pic: ideaboard,
      link: "/ideaboard",
      tooltip: "Idea Board",
    });
  }
  if (chats) {
    slickData.push({
      pic: chat,
      link: "/chat",
      tooltip: "Chat",
    });
  }
  if (todos) {
    slickData.push({
      pic: todo,
      link: "/todolist",
      tooltip: "Todo",
    });
  }
  if (eMagazines) {
    slickData.push({
      pic: eMagazine,
      link: "/e-magazine",
      tooltip: "Podcaster Mag",
    });
  }

  console.log(slickData, "slick");
  return (
    <div
      className={`${styles.bannerToolbar} bannerToolbar ${
        theme === "light" ? additionalClasses : ""
      }`}
      style={{ width: isThubExpanded ? `80px` : "" }}
    >
      <div
        className={`thubCircle ${isThubExpanded ? "expanded" : ""}`}
        onClick={toggleToolbar}
      >
        <h6 className="mt-1 me-3 ms-3">Tool Box</h6>
      </div>
      {isThubExpanded && (
        <div className={`${styles.expandedTool}`}>
          <VerticalSlick slides={slickData} />
        </div>
      )}
    </div>
  );
}

export default BannerToolbar;
